import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { TopNavBar } from "./TopNavBar";
import { Footer } from "./Footer";
import { ScrollToTop } from "@/components/ScrollToTop";

export function MainLayout() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <ScrollToTop />
      <TopNavBar />
      <Box
        component="main"
        sx={{
          flex: 1,
          maxWidth: 1200,
          width: "100%",
          mx: "auto",
          px: { xs: 2, sm: 3 },
          py: 3,
        }}
      >
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
}
